// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { EMPLOYEES } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(EMPLOYEES.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/employees', { method: 'get' });
    yield put(apiSuccess(EMPLOYEES.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createEmployee() {
  yield takeLatest(EMPLOYEES.CREATE_EMPLOYEE, function* (action) {
    yield put(appActions.setLoader('create-edit-employee', true));
    const response = yield apiRequest('api/v1/employees', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(EMPLOYEES.CREATE_EMPLOYEE_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-employee', false));
  });
}

function* editEmployee() {
  yield takeLatest(EMPLOYEES.EDIT_EMPLOYEE, function* (action) {
    yield put(appActions.setLoader('create-edit-employee', true));
    const response = yield apiRequest(`api/v1/employees/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(EMPLOYEES.EDIT_EMPLOYEE_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-employee', false));
  });
}

function* deleteEmployee() {
  yield takeLatest(EMPLOYEES.DELETE_EMPLOYEE, function* (action) {
    yield put(appActions.setLoader('delete-employee', true));
    const response = yield apiRequest(`api/v1/employees/${action.id}`, { method: 'delete' });
    const item = Object.values(response)[0];
    yield put(apiSuccess(EMPLOYEES.DELETE_EMPLOYEE_SUCCESS, { item, type: 'employees' }));
    yield put(appActions.setLoader('delete-employee', false));
  });
}

function* exportEmployees() {
  yield takeLatest(EMPLOYEES.EXPORT_EMPLOYEES, function* (action) {
    yield put(appActions.setLoader('export-employees', true));
    const response = yield apiRequest(
      'api/v1/employees/export',
      { method: 'get' },
      false,
      'employees.xlsx',
    );
    yield put(apiSuccess(EMPLOYEES.EXPORT_EMPLOYEES_SUCCESS, response));
    yield put(appActions.setLoader('export-employees', false));
  });
}

function* importEmployees() {
  yield takeLatest(EMPLOYEES.IMPORT_EMPLOYEES, function* (action) {
    yield put(appActions.setLoader('import-employees', true));
    yield put(
      appActions.showImportModal({
        title: 'Importando empleados',
      }),
    );
    try {
      const tenant = window.location.hostname.split('.')[0];
      const formData = new FormData();
      formData.append('file', action.payload.file);
      formData.append('type', action.payload.type);
      formData.append('socketId', action.payload.socketId);
      formData.append('tenant', tenant);

      const response = yield apiRequest('api/v1/employees/import', {
        method: 'post',
        body: formData,
      });

      if (truthty(response.error)) {
        yield put({ type: EMPLOYEES.IMPORT_EMPLOYEES_ERROR, payload: response.errorMsg });
        yield put(appActions.setError(response.errorMsg));
      } else {
        yield put({ type: EMPLOYEES.IMPORT_EMPLOYEES_SUCCESS, payload: response });
      }
    } catch (error) {
      yield put({
        type: EMPLOYEES.IMPORT_EMPLOYEES_ERROR,
        payload: 'Error al iniciar importación',
      });
    }
  });
}

function* handleImportSocketResponse() {
  yield takeEvery(
    [EMPLOYEES.IMPORT_EMPLOYEES_SOCKET_SUCCESS, EMPLOYEES.IMPORT_EMPLOYEES_SOCKET_ERROR],
    function* (action) {
      yield put(appActions.setLoader('import-employees', false));

      if (action.type === EMPLOYEES.IMPORT_EMPLOYEES_SOCKET_SUCCESS) {
        yield put({ type: EMPLOYEES.GET_STATE_FROM_API });

        const result = action.payload.importResult;
        const processedCount = result?.processed || 'varios';
        yield put(appActions.setSuccess(`✅ ${processedCount} empleados procesados exitosamente`));
      } else if (action.type === EMPLOYEES.IMPORT_EMPLOYEES_SOCKET_ERROR) {
        const errorMsg = action.payload.error || 'Error desconocido en la importación';
        yield put(appActions.setError(`❌ ${errorMsg}`));
      }
    },
  );
}
export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteEmployee);
  yield spawn(createEmployee);
  yield spawn(editEmployee);
  yield spawn(exportEmployees);
  yield spawn(importEmployees);
  yield spawn(handleImportSocketResponse);
}
